<template>
  <div class="cc-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'cc-footer',

  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
.cc-footer {
  height: 50px;
  width: 100%;
  background: #fff;
}
</style>
